module.exports = __webpack_public_path__ + "static/media/7.553d8f5e.jpg";